import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import axiosInstance from '../axiosInstance';
import MyChatComponent from './MyChatComponent'; // Import MyChatComponent
import MyUserContext from '../myUserContext'; // Import MyUserContext

const ArtEventDropdown = ({ eventId, onClose, language, eventType="artEvent", initialArtEvent = null }) => {
  const myUser = useContext(MyUserContext);
  const navigate = useNavigate(); // Initialize useNavigate
  const [artEvent, setArtEvent] = useState(initialArtEvent);

  const dropdownRef = useRef(null);

  const updateArtEvent = () => {
    if (initialArtEvent) {
      return; // Skip fetching if initialArtEvent is provided
    }

    if (eventType === 'recommendation') { // it will live, or not
      axiosInstance
      .get(`/recommendations/${eventId}`)
      .then((response) => {
        setArtEvent({
          event: response.data.recommendation,
          art: response.data.art,
          fromUser: response.data.fromUser,
          toUser: response.data.toUser,
          chat: response.data.chat,
        });
      })
      .catch((error) => {
        console.error(error);
      });
      return;
    }

    if (eventType === 'artEvent') {
      axiosInstance
      .get(`/artEvents/${eventId}`)
      .then((response) => {
        setArtEvent({
          event: response.data.event,
          art: response.data.art,
          chat: response.data.chat,
          eventOwnerUserName: response.data.eventOwnerUserName,
          eventOwnerUserAvatarUrl: response.data.eventOwnerUserAvatarUrl
        });
      })
      .catch((error) => {
        console.error(error);
      });
      return;
    }
  };

  useEffect(() => {
    updateArtEvent();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        event.type === "mousedown"
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    const preventParentScroll = () => {
      document.body.style.overflow = 'hidden'; // Disable parent scrolling
    };

    const restoreParentScroll = () => {
      document.body.style.overflow = ''; // Restore parent scrolling
    };

    preventParentScroll();

    return () => {
      restoreParentScroll();
    };
  }, []);

  if (!artEvent) {
    return <div></div>;
  }
  
  let actualEventType = eventType;
  if (eventType === "artEvent") {
    if (artEvent.event.type === 1) {
      actualEventType = "finished";
    } else if (artEvent.event.type === 2) {
      actualEventType = "todo";
    } else if (artEvent.event.type === 3) {
      actualEventType = "like";
    }
  } // else it's recommendation

  return (
    <div
      ref={dropdownRef}
      className="pb-20 md:pb-0 fixed inset-x-0 bottom-0 rounded-lg shadow-lg max-h-[75vh] overflow-y-auto z-50 w-full md:w-1/4 md:mx-auto sm:max-h-[50vh]"
      style={{ backgroundColor: 'var(--mantine-color-body)', borderTop: '1px solid var(--mantine-color-default-border)' }}
    >
      <div
        className="flex justify-center items-center py-2 mt-2 mb-2 space-x-1 font-bold sticky top-0 z-10"
        style={{ backgroundColor: 'var(--mantine-color-body)' }}
      >
        <span>{language === "ru" ? "Чат в моей библиотеке" : "Chat in my library"}</span>
        <span
          onClick={() => navigate(`/artEvents/${eventId}`)}
          className="cursor-pointer hover:underline"
        >
          {language === "ru" ? " (развернуть)" : " (expand)"}
        </span>
      </div>

      <MyChatComponent key={artEvent.event.chatId} chatId={artEvent.event.chatId} _userChatInfo={artEvent.chat} language={language} myUserInfo={myUser ? myUser.myUserInfo : null} chatOwnerInfo={{type:eventType, id: artEvent.event.id}} isDropdown={true}/>
    </div>
  );
};

export default ArtEventDropdown;
